import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungIngolstadt() {
  return (
    <CityPageTemplate
      city="Ingolstadt"
      slug="ingolstadt"
      intro="In der Autostadt Ingolstadt lohnt es sich, nicht nur in Fahrzeuge zu investieren – wir zeigen Dir wie."
      description="Unabhängige & digitale Finanzberatung für Ingolstadt: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
